import { AccountType } from 'src/types/account'

import { Business } from './Business'
import { Community } from './Community'
import { FarmingForestryRural } from './FarmingForestryRural'
import { Government } from './Government'
import { NGOTrust } from './NGOTrust'
import { SchoolTertiary } from './SchoolTertiary'

export interface AccountFormFieldSetsProps {
  accountType: AccountType
}

export const AccountFormFieldSets = ({
  accountType
}: AccountFormFieldSetsProps) => {
  switch (accountType) {
    case AccountType.FarmingForestryRural:
      return <FarmingForestryRural />
    case AccountType.Business:
      return <Business />
    case AccountType.SchoolTertiary:
      return <SchoolTertiary />
    case AccountType.Community:
      return <Community />
    case AccountType.NGOTrust:
      return <NGOTrust />
    case AccountType.Government:
      return <Government />
    default:
      return null
  }
}
